import { apiSlice } from "./apiSlice";
import { ORDERS_URL } from "../constants";

export const orderApiSlice = apiSlice.injectEndpoints({
  tagTypes: ["Order"],
  endpoints: (builder) => ({
    // Create a new order (Customer)
    createOrder: builder.mutation({
      query: (data) => ({
        url: ORDERS_URL,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Order"],
    }),

    // Get logged-in user's orders (Customer)
    getMyOrders: builder.query({
      query: () => ({
        url: `${ORDERS_URL}/my`,
      }),
      providesTags: ["Order"],
      keepUnusedDataFor: 5,
    }),
getVendorCustomers: builder.query({
  query: () => ({
    url: `${ORDERS_URL}/vendor/customers`, // e.g. /api/orders/vendor/customers
  }),
  providesTags: ['Customer'],
  keepUnusedDataFor: 5,
}),
getVendorDistinctProducts: builder.query({
  query: (vendorId) => ({
    url: `${ORDERS_URL}/vendor/${vendorId}/distinct-products`,
  }),
  providesTags: ['Product'],
  keepUnusedDataFor: 5,
}),
    // Get vendor's orders
      getVendorOrders: builder.query({
    query: ({ page = 1, limit = 10, customer,  startDate, endDate, status } = {}) => {
      const params = new URLSearchParams();

      params.append('page', page);
      params.append('limit', limit);

      if (customer) params.append('customer', customer);
      if (startDate) params.append('startDate', startDate);
      if (endDate) params.append('endDate', endDate);
      if (status) params.append('status', status);

      return {
        url: `${ORDERS_URL}/vendor?${params.toString()}`,
      };
    },
    providesTags: ['Order'],
    keepUnusedDataFor: 5,
  }),


    // ✅ Get vendor's *pending* orders
    getVendorPendingOrders: builder.query({
      query: () => ({
        url: `${ORDERS_URL}/vendor/pending`,
      }),
      providesTags: ["Order"],
      keepUnusedDataFor: 5,
    }),

    // Get a single order by ID
    getOrderById: builder.query({
      query: (id) => ({
        url: `${ORDERS_URL}/${id}`,
      }),
      keepUnusedDataFor: 5,
    }),
    deleteOrder: builder.mutation({
  query: (orderId) => ({
    url: `${ORDERS_URL}/orders/${orderId}`,
    method: "DELETE",
  }),
  invalidatesTags: ["Order"], // Optional: Invalidate order-related cache
}),


    // Update order status (Vendor)
    updateOrderStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `${ORDERS_URL}/${id}/status`,
        method: "PUT",
        body: { status },
      }),
      invalidatesTags: ["Order"],
    }),

    // Mark order as delivered (Admin or Vendor)
    markOrderDelivered: builder.mutation({
      query: (orderId) => ({
        url: `${ORDERS_URL}/mark-delivered`,
        method: "PUT",
        body: { orderId },
      }),
      invalidatesTags: ["Order"],
    }),
    getPendingOrdersByArea: builder.mutation({
      query: (area) => ({
        url: `${ORDERS_URL}/pending-by-area`,
        method: 'POST',
        body: { area },
      }),
      invalidatesTags: ['Order'],
    }),

    generateGSTR1Report: builder.query({
      query: ({ startDate, endDate }) => ({
        url: `${ORDERS_URL}/gstr1/report`,
        params: { startDate, endDate },
      }),
      providesTags: ["Order"],
      keepUnusedDataFor: 5,
    }),
  }),
});

export const {
  useCreateOrderMutation,
  useGetMyOrdersQuery,
  useGetVendorOrdersQuery,
  useGetVendorPendingOrdersQuery, // ✅ New hook
  useGetOrderByIdQuery,
  useUpdateOrderStatusMutation,
  useMarkOrderDeliveredMutation,
  useGenerateGSTR1ReportQuery,
  useLazyGenerateGSTR1ReportQuery,
  useGetVendorCustomersQuery,
  useGetVendorDistinctProductsQuery,
  useDeleteOrderMutation,
  useGetPendingOrdersByAreaMutation,
} = orderApiSlice;
